import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  trainingSetGroup: {
    ...theme.mixins.appContainer,
    padding: theme.spacing(2, 0),

    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1, 0),
    },
  },
  setGroupHeader: {
    width: '100%',
    padding: theme.spacing(1, 2, 2),
  },
  trainingSetWrapperDivider: {
    borderTop: `2px solid ${theme.palette.primary.main}`,
    paddingTop: theme.spacing(2),
  },
}));
